import React from "react"
import {useStaticQuery, graphql} from "gatsby"

const FooterAsset=() =>{
    const data = useStaticQuery(
        graphql`
          query {
            site {
              siteMetadata {
                author
              }
            }
          }
        `
      )
    return(
        <footer className="footer container">
            <p>By {data.site.siteMetadata.author} - 2020</p>
            <div>
              <a href="https://github.rahul3v.xyz" target="_blank" rel="noopener noreferrer">Github</a>
              <a href="https://www.patreon.com/rahul3v" target="_blank" rel="noopener noreferrer">Patreon</a>
            </div>
        </footer>
    )
}
export default FooterAsset;